import type { FigmaIconProps } from './types';

export const IconFigmaDocument = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.06641 13.3333V2.66667C2.06641 2.15391 2.27024 1.66205 2.63281 1.29948C2.99538 0.936909 3.48725 0.733073 4 0.733073H10L10.0592 0.736328C10.1966 0.749956 10.326 0.810385 10.4245 0.908854L13.7578 4.24219C13.8703 4.35471 13.9336 4.50754 13.9336 4.66667V13.3333C13.9336 13.8461 13.7298 14.338 13.3672 14.7005C13.0046 15.0631 12.5128 15.2669 12 15.2669H4C3.48725 15.2669 2.99538 15.0631 2.63281 14.7005C2.27024 14.338 2.06641 13.8461 2.06641 13.3333ZM3.26693 13.3333C3.26693 13.5278 3.34424 13.714 3.48177 13.8516C3.6193 13.9891 3.80551 14.0664 4 14.0664H12C12.1945 14.0664 12.3807 13.9891 12.5182 13.8516C12.6558 13.714 12.7331 13.5278 12.7331 13.3333V4.91536L9.7513 1.93359H4C3.80551 1.93359 3.6193 2.01091 3.48177 2.14844C3.34424 2.28596 3.26693 2.47217 3.26693 2.66667V13.3333Z"
      fill={color}
    />
    <path
      d="M8.73307 4V1.33333C8.73307 1.00196 9.00196 0.733073 9.33333 0.733073C9.6647 0.733073 9.93359 1.00196 9.93359 1.33333V4C9.93359 4.19449 10.0109 4.3807 10.1484 4.51823C10.286 4.65576 10.4722 4.73307 10.6667 4.73307H13.3333C13.6647 4.73307 13.9336 5.00196 13.9336 5.33333C13.9336 5.6647 13.6647 5.93359 13.3333 5.93359H10.6667C10.1539 5.93359 9.66205 5.72976 9.29948 5.36719C8.93691 5.00462 8.73307 4.51275 8.73307 4Z"
      fill={color}
    />
    <path
      d="M6.66667 5.39974C6.99804 5.39974 7.26693 5.66863 7.26693 6C7.26693 6.33137 6.99804 6.60026 6.66667 6.60026H5.33333C5.00196 6.60026 4.73307 6.33137 4.73307 6C4.73307 5.66863 5.00196 5.39974 5.33333 5.39974H6.66667Z"
      fill={color}
    />
    <path
      d="M10.6667 8.06641C10.998 8.06641 11.2669 8.3353 11.2669 8.66667C11.2669 8.99804 10.998 9.26693 10.6667 9.26693H5.33333C5.00196 9.26693 4.73307 8.99804 4.73307 8.66667C4.73307 8.3353 5.00196 8.06641 5.33333 8.06641H10.6667Z"
      fill={color}
    />
    <path
      d="M10.6667 10.7331C10.998 10.7331 11.2669 11.002 11.2669 11.3333C11.2669 11.6647 10.998 11.9336 10.6667 11.9336H5.33333C5.00196 11.9336 4.73307 11.6647 4.73307 11.3333C4.73307 11.002 5.00196 10.7331 5.33333 10.7331H10.6667Z"
      fill={color}
    />
  </svg>
);
